const fuelTranslate: Record<string, string> = {
  'FUEL.UNLEADED': 'Bencina',
  'FUEL.DIESEL': 'Diesel',
  'FUEL.ELECTRIC': 'Eléctrico',
  'FUEL.HYBRID': 'Híbrido',
  'FUEL.HYBRID_PLUG': 'Híbrido enchufable',
  'FUEL.NATURAL_GAS': 'Gas',
  'FUEL.HYDROGEN': 'Hidrógeno', // REVERTED: Back to original frontend translation
  'FUEL.ETHANOL': 'Otro', // REVERTED: Back to original frontend translation
}

export default fuelTranslate
